export const NB_STEP1_VALUES = 3;
export const NB_STEP2_BLOCKS = 6;
export const NB_STEP2_QUESTIONS_BY_BLOCK = 6;
export const NB_STEP2_QUESTIONS = NB_STEP2_BLOCKS * NB_STEP2_QUESTIONS_BY_BLOCK;
export const NB_STEP2_RANK_QUESTIONS = 3;
export const NB_STEP3_QUESTIONS = 24;
export const STATUS_ADMIN = 'admin';
// Likert is named after the Likert Scale https://en.wikipedia.org/wiki/Likert_scale
export const LIKERT_MAX_VALUE = 6;
